export default function (instance) {
  return {
    get_list(payload) {
      return instance.post(`reg/get_list?page=${payload.page}`, {
        per_page: payload.perPage,
        searchByFio: payload.searchByFio
      });
    },
  };
}
